import imgItem from '@/assets/images/pngs/item1.png';
import imgUpload from '@/assets/images/pngs/cloud-upload.png';
import { bytesToMB } from '@/utils/file';
import { toastify } from '@/utils/toastify';
import { useStore } from '@/hooks/useStore';
import { useState } from 'react';
import { t } from 'i18next';
interface UploadImageProps {
    path?: string,
    alt?: string,
    className?: string,
    onSelectedImage: Function,
    isUpload?: boolean,
    disabled?: boolean
}

const UploadImage = ({ path, alt, className = '', onSelectedImage = () => { }, isUpload = false, disabled = false }: UploadImageProps) => {
    const {
        modalStore: { showAlertModal, hideModal }
    } = useStore();
    const handleFileInputReset = () => {
        const fileInput = document.getElementById('upload') as HTMLInputElement;
        fileInput.value = '';
        // setFile(undefined);
    };
    const showError = (text: string) => {
        showAlertModal({
            saveButton: false,
            cancelButton: false,
            closeWhenOutside: true,
            type: 'error',
            content: text
        });
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files) return undefined;
        const fileToUpload: File = Array.from(files)[0];
        const sizeInMB: number = bytesToMB(fileToUpload?.size);
        if (sizeInMB > 10) {
            showError(t('messages.overSize', { size: 10 }));
            return undefined;
        }
        if (fileToUpload.type !== 'image/png' && fileToUpload.type !== 'image/jpeg') {
            showError(t('messages.invaildFormat'));
            return undefined;
        }
        console.log(fileToUpload);

        setFile(fileToUpload);
        onSelectedImage(fileToUpload);
        setChanged(true);
    };

    const [file, setFile] = useState<File | undefined>(undefined);
    const [changed, setChanged] = useState<boolean>(false);
    return (
        <div className=''>
            <input
                type='file'
                style={{ display: 'none' }}
                id='upload'
                accept='image/jpeg, image/png'
                onClick={handleFileInputReset}
                onChange={handleFileChange}
                disabled={disabled}
            />
            {isUpload || changed ?
                (
                    file ?
                        (
                            <label htmlFor='upload'>
                                <img alt={file.name || ''} src={URL.createObjectURL(file)} className={`w-full rounded-sm ${className}`} />
                            </label>
                        ) :
                        (
                            <label htmlFor='upload' className='w-full rounded-sm mt-[6px] bg-bgInput border-[1px] border-bgMenubar h-[calc(100vw-32px)] flex flex-col justify-center items-center content-center'>
                                <img src={imgUpload} className='w-10 h-10' alt={imgUpload} />
                                <p className='text-[15px] text-colorTextUpload py-[10px]'>ファイルを選択</p>
                                <p className='text-[15px] text-colorTextUpload'>最大アップロードサイズ： 10MB</p>
                                <p className='text-[15px] text-colorTextUpload '>アップロード可能な形式：JPG, JPEG, PNG</p>
                            </label>
                        )
                ) :
                (
                    <label htmlFor='upload'>
                        <img alt={alt || ''} src={path || imgItem} className={`w-full rounded-sm ${className}`} />
                    </label>

                )}

        </div>
    );
};

export default UploadImage;
